import * as React from 'react';
import DataTable from 'react-data-table-component';
import { BiologicalUnits, BiologicalUnitDetails } from '../../../TableColumns';
import { IStructureInfo } from '../../../IMainState';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Col, Row, Label } from 'reactstrap';
import { clientUrlPrefix } from "../../../settings";

interface ICardProps {
    data: IStructureInfo[];
    unselectAll?: boolean;
    setSelectedRowsF: (selectedRow: IStructureInfo | null) => void;
    jobId: string;
}

interface IState {
    counter: number,
    modal: number,
    imageURL: string
}

class Table extends React.Component<ICardProps, IState> {

    state: IState = {
        counter: 1,
        modal: null,
        imageURL: null,
    }

    componentDidUpdate(prevProps: Readonly<ICardProps>, prevState: Readonly<IState>) {
        if (this.props.data !== prevProps.data || this.props.unselectAll !== prevProps.unselectAll) {
            this.setState({
                counter: this.state.counter + 1
            });
        }
    }

    handleChange = (tableState) => {
        console.log(tableState);
        this.props.setSelectedRowsF(tableState.selectedRows[0] ?? null);
    };

    isPreselected = (row: IStructureInfo): boolean => {
        if (this.props.unselectAll) {
            return false;
        }
        return this.props.data.length > 0 && row === this.props.data[0];
    }

    fetchImage = async (number) => {
        const url = clientUrlPrefix + '/api/pdb/image/' + this.props.jobId + '/' + (number);
        const res = await fetch(url);
        const imageBlob = await res.blob();
        const imageObjectURL = URL.createObjectURL(imageBlob);
        
        this.setState({
            imageURL: imageObjectURL
        });
    };

    handleClickModal = (number) => {

        console.log(this.props.data[number]["table"]);

        this.fetchImage(number + 1);

        this.setState({
            modal: number + 1,
        });

    };

    closeModal = () => {
        this.setState({
            modal: null,
        });
    }

    render() {
        return (
            <React.Fragment key={this.state.counter}>
                <DataTable
                    columns={[
                        ...BiologicalUnits,
                        {
                            name: 'Details',
                            cell: (row, index) => (
                                <Button
                                    style={{ width: '40%', marginLeft: '5%', marginRight: '5%' }}
                                    onClick={() => this.handleClickModal(index)}>
                                    <img
                                        src='images/book.png'
                                        style={{ width: '100%' }}
                                        alt='Show details.'></img>
                                </Button>
                            ),
                            button: true,
                        },
                    ]}
                    data={this.props.data}
                    selectableRows
                    onSelectedRowsChange={this.handleChange}
                    selectableRowsSingle={true}
                    selectableRowSelected={this.isPreselected}
                    highlightOnHover={true}
                    selectableRowsHighlight={true}
                    dense
                />

            {this.state.modal !== null && (
                <Modal size="400px" isOpen={true} centered={true} fade={false} toggle={this.closeModal}>
                    <ModalHeader toggle={this.closeModal}>
                        {"Biological unit " + this.state.modal}
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <Row>
                                <Col>
                                <Row><Col><strong>Burried surface area [A<sup>2</sup>]: </strong></Col><Col>{this.props.data[this.state.modal - 1]["burriedSurfaceArea"] !== 0 ? this.props.data[this.state.modal - 1]["burriedSurfaceArea"] : "-"}</Col></Row>
                                <Row><Col><strong>Surface area [A<sup>2</sup>]: </strong></Col><Col>{this.props.data[this.state.modal - 1]["surfaceArea"] !== 0 ? this.props.data[this.state.modal - 1]["surfaceArea"] : "-"}</Col></Row>
                                <Row><Col><strong>Change in solvent free energy [kcal/mol]:</strong></Col><Col>{this.props.data[this.state.modal - 1]["changeInSolvent"] !== 0 ? this.props.data[this.state.modal - 1]["changeInSolvent"] : "-"}</Col></Row>
                                <br/>
                                <DataTable
                                    columns={[...BiologicalUnitDetails, {}]}
                                    data={this.props.data[this.state.modal - 1]["table"]}
                                    selectableRows={false}
                                    pagination={false}
                                    highlightOnHover={true}
                                    dense
                                />
                                </Col>
                                <Col><img src={this.state.imageURL}/></Col>
                            </Row>
                        </div>
                        
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.closeModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            )}
            </React.Fragment>
        );
    }
}

export default Table;
